import { z } from 'zod';

export type Brand = z.infer<typeof BrandSchema>;

export const BrandSchema = z.object({
  colors: z.array(z.string()).length(3),
  logo: z.string(),
});

export const BrandFetchResponseSchema = z.object({
  brand: BrandSchema,
});
